import {Editor, type EditorLevelsOptions} from '../interfaces/editor'
import {Node, type NodeEntry} from '../interfaces/node'

export function* levels<T extends Node>(
  editor: Editor,
  options: EditorLevelsOptions<T> = {},
): Generator<NodeEntry<T>, void, undefined> {
  const {at = editor.selection, reverse = false} = options
  let {match} = options

  if (match == null) {
    match = () => true
  }

  if (!at) {
    return
  }

  const levels: NodeEntry<T>[] = []
  const path = Editor.path(editor, at)

  for (const [n, p] of Node.levels(editor, path, editor.schema)) {
    if (!match(n, p)) {
      continue
    }

    levels.push([n, p] as NodeEntry<T>)
  }

  if (reverse) {
    levels.reverse()
  }

  yield* levels
}
